import { render, staticRenderFns } from "./FieldCourseSkill.vue?vue&type=template&id=5819dbe2&"
import script from "./FieldCourseSkill.vue?vue&type=script&lang=ts&"
export * from "./FieldCourseSkill.vue?vue&type=script&lang=ts&"
import style0 from "./FieldCourseSkill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports